export default "__VITE_ASSET__DbMg8xHl__"